// api/index.js
import axios from 'axios';
import baseURL from '../apiConfig.js';
import defaultLanguage from '../../defaultLanguage.js';
// 创建一个 Axios 实例
const api = axios.create({
  baseURL:baseURL,
  timeout: 10000, // 请求超时时间
  withCredentials: true
  
});

// 在请求拦截器中设置 token
api.interceptors.request.use(
  config => {
    let token = localStorage.getItem('token');
    let lang = sessionStorage.getItem('UNI_LOCALE') || defaultLanguage;
    config.headers['Lang'] = lang;
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 设置 Axios 响应拦截器
api.interceptors.response.use(
  response => {
    if (response.data.code === -1 ) {
      localStorage.clear()
    }
    return response;
  },
  error => {
    console.log(error)
    const status = error.response ? error.response.status : 0;
    if (status === -401) {
      localStorage.clear()
    }
    return Promise.reject(error);
  }
);

const get = (url, params) => api.get(url, { params });
const post = (url, data) => api.post(url, data);

export const login = (data) => post('api/user/user/login',data);
export const heartbeat = () => post('api/user/heartbeat');

export const deal = (data) => get('api/exchange/buy',data); //买多买少
export const homecontent = () => get('api/index'); //主页信息
export const userinfo = () => get('api/user/info'); //用户信息
export const kefu = () => get('api/kefu/list').then((res) => {
  const list = res.data?.data?.list;
  if (!list?.length || !localStorage.getItem('token')) {
    return res;
  }
  return userinfo().then((userRes) => {
    const uid = userRes.data?.data?.uid;
    if (uid) {
      list.forEach((item) => {
        if (item.href) {
          item.href = `${item.href}&pid=${uid}`;
        }
      });
    }
    return res;
  }).catch(() => res);
}); //客服信息
export const bankcard = (data) => post('api/bankcard',data);//添加银行卡
export const getbankcard = () => get('api/bankcard',);//查询银行卡

export const ethPrice = (data) => get('api/market/detail/merged',data); //聚合行情
export const list = (data) => get('api/exchange/buy/list',data); //交易记录
export const moneyChangeRecord = (data) => get('api/moneyChangeRecord/list',data); //账变记录
// export const addresses = (data) => get('api/charge/addresses',data); //获取充值地址
export const addresses = (data) => post('api/cbpay/support_fiats',data); //获取充值地址
export const getDict = (data) => get('api/getDict',data); //字典


export const cbpay = (data) => post('api/cbpay',data); //充值 
export const amountlimits = (data) => post('api/cbpay/amount_limits',data); //最大与最小充值
export const depositlist = (data) => get('api/charge/list',data); //充值记录

export const depositTypeList = () => get('api/deposit/type'); //充值方式

export const deposit = (data) => post('api/deposit/create',data); //充值

export const upload = (data) => post('api/file/upload',data); //上传充值截图

export const mhy = (data) => get('api/mhy/list',data); //秒合约

export const withdraw = (data) => post('api/withdraw',data); //提现
export const withdrawlist = (data) => get('api/withdraw/list',data); //提现
export const withdrawDetail = (data) => get('api/withdraw/detail',data); //提现单条

export const chatMessages = () => get('api/chat/messages');
export const chatSend = (data) => post('api/chat/send', data);
export const chatRead = () => post('api/chat/read');
